<template>
  <layout-base-center>
    <div :class="$style.login">
      <h1 :class="$style.title">
        {{ $t('user.authorization') }}
      </h1>
      <div>
        <div>
          <input
            v-model="username"
            :class="$style.input"
            :placeholder="$t('user.username')"
          >
        </div>
        <div :class="$style.passwordContainer">
          <input
            v-if="showPassword"
            v-model="password"
            :class="$style.input"
            :placeholder="$t('user.password')"
          >
          <input
            v-if="!showPassword"
            v-model="password"
            type="password"
            :class="$style.input"
            :placeholder="$t('user.password')"
          >
          <img
            v-if="!showPassword"
            :title="$t('user.showPassword')"
            src="@/assets/images/icons/navigation/hide.svg"
            :class="$style.eyeImg"
            @click="showPassword = true"
          >
          <img
            v-if="showPassword"
            :title="$t('user.hidePassword')"
            src="@/assets/images/icons/navigation/show.svg"
            :class="$style.eyeImg"
            @click="showPassword = false"
          >
        </div>
        <div :class="$style.buttonContainer">
          <button
            :class="$style.button"
            :disabled="isBlocked"
            @click="login(false)"
          >
            {{ $t('user.enter') }}
          </button>
        </div>
        <switch-locale :class="$style.buttonContainer" />
      </div>
    </div>
    <telegram-auth
      id="tgAuth"
      :class="$style.modal"
      @close="closeModal('tgAuth')"
      @send="login"
    />
  </layout-base-center>
</template>

<script>
  import LayoutBaseCenter from '@/layouts/base-center.vue';
  import TelegramAuth from '@/views/user/auth-modal.vue';
  import SwitchLocale from '@/components/common/locale/locale.vue';
  import { openToast, TOAST_TYPE } from '@/utils/open-toast';

  export default {
    components: {
      LayoutBaseCenter,
      TelegramAuth,
      SwitchLocale,
    },
    data: () => ({
      username: '',
      password: '',
      showPassword: false,
      isBlocked: false,
    }),
    methods: {
      closeModal(id) {
        document.getElementById(id).style.display = 'none';
      },
      openModal(id) {
        document.getElementById(id).style.display = 'flex';
      },
      startTimout() {
        setTimeout(() => {
          this.isBlocked = false;
        }, 60000);
      },
      login(authCode) {
        if (this.isBlocked) return;
        const { username, password } = this;
        this.$store
          .dispatch('user/login', { username, password, authCode })
          .then(() => {
            if (this.$store.getters['user/telegramAuthNeeded']) this.openModal('tgAuth');
            else this.$router.push({ name: 'computers' });
          })
          .catch((reason) => {
            if (reason.response.status === 403) {
              this.isBlocked = true;
              openToast(reason.response.data.message, TOAST_TYPE.ERROR);
              this.startTimout();
            } else {
              // eslint-disable-next-line no-alert
              alert(reason.response.data.message);
            }
          });
      },
    },
  };
</script>

<style lang="scss" module>
  .login {
    background: $white;
    box-shadow: $shadow;
    padding: 20px;
    width: 500px;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .input {
    height: 30px;
    width: 300px;
    margin: 10px;
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
    width: 300px;
    margin: 10px;
    height: 35px;
  }

  .button {
    width: 115px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    color: white;
    cursor: pointer;
    &:disabled {
      cursor: not-allowed;
      background: $branchColor;
      border: $branchColor;
    }
  }

  .modal {
    display: none;
    z-index: 3000;
  }

  .eyeImg {
    margin-left: -11%;
    cursor: pointer;
  }

  .passwordContainer {
    display: flex;
  }
  .switchLang {
    color: grey;
    gap: 10px;
    align-items: center;
  }
  .btnLang {
    cursor: pointer;
    padding: 0;
    border: none;
    font: inherit;
    color: grey;
    background-color: transparent;
    &:hover {
      opacity: 0.7;
      transition: opacity 200ms linear;
    }
  }
  .btnActive {
    border-bottom: 1px solid gray;
  }
</style>
